import { makeQueryStringDync, errorServeiceHandler, makeQueryFormDataDyn } from '../helper'
const state = {
  name: 'abcs'
}
const actions = {
  getTransactions: (context, filterData) => {
    let url = '/subscriber/v1/subscriber/transactionhistory'
    return new Promise((resolve, reject) => {
      let queryStr = ''
      queryStr = makeQueryStringDync(filterData)
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      })
        .then(errorServeiceHandler)
        .then((response) => {
          return response.json()
        }).then((data) => {
            resolve(data)
        }).catch((error) => {
          if (context.getters.getMode == "development") {
            resolve([{"created":"6th August 2020","description1":"NXTB Local Channels Pack","description2":"Subscription start date: 06\/08\/20","transactiontype":"Subscription Charges","amount":"0.00"},{"created":"6th August 2020","description1":"Online Recharge - NXTDIGITAL - Customer Payment to LCO","description2":"","transactiontype":"Account Recharge","amount":"0.00"},{"created":"18th July 2020","description1":"Foundation + Hindi Popular Pack 3M","description2":"Subscription start date: 18\/07\/20","transactiontype":"Subscription Charges","amount":"390.00"},{"created":"18th July 2020","description1":"Foundation + Hindi Popular Pack 3M","description2":"Subscription start date: 18\/07\/20","transactiontype":"Subscription Charges","amount":"509.25"},{"created":"18th July 2020","description1":"Online Recharge - NXTDIGITAL - Customer Payment to LCO","description2":"","transactiontype":"Account Recharge","amount":"899.25"}])
            return
          }
          reject(error)
        });
    });
  }
};

export default {
  state, actions
};


// WEBPACK FOOTER //
// ./src/store/modules/transaction.js